import React, { forwardRef, useEffect, useState } from 'react';
import { useEvent, useForwardedRef } from '@anton.bobrov/react-hooks';
import { Timeline, vevet } from '@anton.bobrov/vevet-init';
export var FadeContentItem = forwardRef(function (_a, forwardedRef) {
    var className = _a.className, children = _a.children, duration = _a.duration, stateProp = _a.state, onShowProp = _a.onShow, onShowProgressProp = _a.onShowProgress, onShownProp = _a.onShown, onHideProp = _a.onHide, onHiddenProp = _a.onHidden;
    var ref = useForwardedRef(forwardedRef);
    var onShow = useEvent(onShowProp);
    var onShowProgress = useEvent(onShowProgressProp);
    var onShown = useEvent(onShownProp);
    var onHide = useEvent(onHideProp);
    var onHidden = useEvent(onHiddenProp);
    var render = useEvent(function (state, progress) {
        if (state === 'show') {
            ref.current.style.opacity = "".concat(progress);
        }
        if (state === 'hide') {
            ref.current.style.opacity = "".concat(1 - progress);
        }
    });
    var initialState = useState(stateProp)[0];
    useEffect(function () {
        if (!vevet) {
            return undefined;
        }
        if (initialState === stateProp) {
            return undefined;
        }
        if (stateProp !== 'hide' && stateProp !== 'show') {
            return undefined;
        }
        var element = ref.current;
        if (stateProp === 'show') {
            onShow();
        }
        else if (stateProp === 'hide') {
            onHide();
        }
        var timeline = new Timeline({ duration: duration });
        timeline.addCallback('progress', function (_a) {
            var easing = _a.easing, progress = _a.progress;
            render(stateProp, easing);
            if (stateProp === 'show') {
                onShowProgress(element, progress);
            }
            if (stateProp === 'show' && progress === 1) {
                onShown();
            }
            else if (stateProp === 'hide' && progress === 1) {
                onHidden();
            }
        });
        timeline.play();
        return function () { return timeline.destroy(); };
    }, [
        initialState,
        stateProp,
        ref,
        duration,
        onShow,
        onShowProgress,
        onShown,
        onHide,
        onHidden,
        render,
    ]);
    return (React.createElement("div", { ref: ref, className: className, style: { opacity: initialState === 'active' ? 1 : 0 } }, children));
});
FadeContentItem.displayName = 'FadeContentItem';
//# sourceMappingURL=index.js.map